import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  loadDoctorPrenotationList,
  loadPrenotationList,
  updatePage,
} from "../../redux/reducer/prenotationReducer";
import { useAppDispatch } from "../../redux/";
import BoxNullItems from "../boxNullItems";
import Pagination from "../pagination";
import PrenotationRow from "./prenotationRow";
import TableHeader from "./prenotationRowHeader";
import PrenotationListCalendar from "./prenotationListCalendar";
import PopUpViewPrenotationByTimeslot from "../popUpViewPrenotationByTimeslot";
import moment from "moment";
import PopUpNote from "../popUpNote";
import { hasModules } from "../../utils/helpers";

const PrenotationTable = () => {
  const { user } = useSelector((state: any) => state.login);
  const { list, countListAll, page } = useSelector(
    (state: any) => state.prenotation
  );

  let result: any[] = list.filter(
    (prenotation: any) => prenotation?.bookingId !== ""
  );
  const [
    showPopUpViewPrenotationByTimeslot,
    setShowPopUpViewPrenotationByTimeslot,
  ] = useState(false);
  const [selectTimeslot, setSelectTimeslot] = useState("");
  const [bookingId, setBookingId] = useState("");
  const [bookingEventId, setBookingEventId] = useState("");
  const pageList: number = Number(process.env.REACT_APP_PAGE_LIST) || 10;
  const { filterType } = useSelector((state: any) => state.timeslot);
  let pageTotal = Math.ceil(Number(countListAll) / pageList);
  const dispatch = useAppDispatch();
  const [pageIndex, setPageIndex] = useState(1);
  const [selectedDay, setSelectedDay] = useState("");
  const [showPopUpNote, setShowPopUpNote] = useState(false);
  const [attendanceFullName, setAttendanceFullName] = useState("");


  useEffect(() => {
    if (!user?.modules?.length) return;

    dispatch(updatePage(pageIndex));
    if (user.modules.includes("FEDERFARMA_DOCTOR")) {
      dispatch(loadDoctorPrenotationList());
    } else {
      dispatch(loadPrenotationList());
    }
  }, [pageIndex, user]);

  useEffect(() => {
    setPageIndex(page);
  }, [page]);

  // useEffect(() => {
  //   dispatch(loadListCalendar());
  // }, [])

  const openPopUpViewPrenotationByTimeslot = (
    bookingId: any,
    timeslot: any,
    eventId:string
  ) => {
    let selectTimeslotId = timeslot._id
    if(hasModules(user,"FEDERFARMA_DOCTOR")){
    selectTimeslotId = timeslot.timesString;
    }
    setSelectedDay(moment(timeslot.startDate).format("YYYY-MM-DD"));
    setSelectTimeslot(selectTimeslotId);
    setBookingId(bookingId);
    setBookingEventId(eventId);
    setShowPopUpViewPrenotationByTimeslot(true);
  };

  const closePopUpNote = () => {
    setBookingId("");
    setBookingEventId("");
    setAttendanceFullName("");
    setShowPopUpNote(false);
  };
  const openPopUpNote = (booking: string, attendanceFullName: string,bookingEventId:string) => {
    setBookingId(booking);
    setAttendanceFullName(attendanceFullName);
    setBookingEventId(bookingEventId)
    setShowPopUpNote(true);
  };
  return (
    <>
      <div className="row m-0">
        <div className="col-lg-12">
          <div className="Section">
            {filterType == "list" ? (
              <>
                <table className="table">
                  <TableHeader />
                  <PrenotationRow
                    openPopUpNote={openPopUpNote}
                    openPopUpViewPrenotationByTimeslot={
                      openPopUpViewPrenotationByTimeslot
                    }
                    prenotation={result}
                  />
                </table>
                {result.length !== 0 && (
                  <>
                    <Pagination
                      onPageChange={setPageIndex}
                      pageIndex={pageIndex}
                      pageTotal={pageTotal}
                    />
                  </>
                )}
                {showPopUpViewPrenotationByTimeslot && (
                  <PopUpViewPrenotationByTimeslot
                    selectedDay={selectedDay}
                    selectedTimeslotId={selectTimeslot}
                    selectedBookingId={bookingId}
                    closePopUp={() =>
                      setShowPopUpViewPrenotationByTimeslot(false)
                    }
                  />
                )}
                {result.length === 0 && (
                  <BoxNullItems icon="list" label={t("not-prennotations")} />
                )}
              </>
            ) : (
              <PrenotationListCalendar />
            )}
          </div>
        </div>
      </div>
      <PopUpNote
        bookingId={bookingId}
        eventId={bookingEventId}
        attendanceFullName={attendanceFullName}
        show={showPopUpNote}
        closePopUp={() => closePopUpNote()}
      />
    </>
  );
};

export default PrenotationTable;
